<template>
    <div class="gastouder">
        <gastouder-default />
    </div>
</template>

<script>
import GastouderDefault from '@/views/gastouder/Default'

export default {
    name: 'gastouder',
    components: {
        GastouderDefault
    }
}
</script>

<style scoped>
</style>
